<template>
    <div class="vx-col w-full mb-base">
      <vx-card>
        <div class="vx-row">
            <div class="vx-col sm:w-2/2 w-full mb-2">
                รูปภาพ <input type="file" class="w-full" ref="input1" label="รูปภาพ" @change="previewImage" accept="image/*"/>
            </div>
        </div>
        <div class="vx-row" v-if="img1 || background">
            <div class="vx-col sm:w-2/2 w-full mb-2">
                <img class="preview" height="300" width="300" :src="(img1)?img1:background">
            </div>
        </div>
    </vx-card>
    <br>
    <!-- <vx-card title="ธนาคารถอน SCB">
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input class="w-full" label="Username" v-model="withdraw.scb.username" />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-input class="w-full" label="Password" v-model="withdraw.scb.password" />
            </div>
        </div>
    </vx-card>
    <br> -->
    <div class="vx-row">
        <div class="vx-col w-full" style="text-align:center;">
            <vs-button class="mr-3 mb-2" @click="updateUser">SAVE</vs-button>
        </div>
    </div>
    </div>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/database'
import _ from 'lodash'
const axios = require('axios').default;
export default {
  data () {
    return {
        img1:'',
        background:'',
    }
  },
  watch: {
    datefrom () {
      this.calculate();
    },
    dateto () {
      this.calculate();
    },
  },
  computed: {
    userLogin(){
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    previewImage(event) {
      this.imageData = event.target.files[0];
      this.img1 = URL.createObjectURL(this.imageData);
      //this.onUpload()
    },
    isNumberOnly(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    async updateUser(){
        console.log(this.img1)
        if(this.img1 !== ''){
        const imagetype = this.imageData.name.split('.');
        const storageRef = firebase.storage().ref(`images/background2.${imagetype[imagetype.length-1]}`).put(this.imageData);
        await storageRef.on(`state_changed`,snapshot=>{
            this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
          }, error=>{console.log(error.message)},
        ()=>{
            storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                firebase.database().ref('background2').update({image:url})
            });
        });
      }
    },
  },
  async created () {
    // Register Module UserManagement Module
    const bank = (await firebase.database().ref(`/background2`).once('value')).val();
    if(bank){
        this.background = bank.image
    }
  },
}

</script>
